import React from 'react';
import { useField } from 'react-final-form';

import { HelpOutlineOutlined } from '@mui/icons-material';
import { Checkbox, FormControlLabel, Stack, Tooltip, Typography } from '@mui/material';

export default function StrictRenderingCheckboxField() {
  const { input } = useField<boolean>('configuration.strictVariablesRendering');
  return (
    <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
      <FormControlLabel
        label={<Typography variant="body2">Don’t send emails with missing data</Typography>}
        control={
          <Checkbox
            checked={input.value}
            onChange={(ev, checked) => {
              input.onChange(checked);
            }}
          />
        }
      />
      <Tooltip title="Prevent emails from sending if the template has a referenced variable (eg. {{name}}) without matching data. Unsent emails can be inspected from your activity page.">
        <HelpOutlineOutlined fontSize="small" sx={{ color: 'grey.600' }} />
      </Tooltip>
    </Stack>
  );
}
